// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3JcjZ","title":"Info_title__30xQ3","selects":"Info_selects__iqhfF","requiredAsterisk":"Info_requiredAsterisk__1_tNR"};